import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function AnimatedImage({ src, alt, className = "", floating = false, tilt = false }) {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const smoothX = useSpring(x, { stiffness: 120, damping: 18 });
  const smoothY = useSpring(y, { stiffness: 120, damping: 18 });
  const rotateX = useTransform(smoothY, [-60, 60], [6, -6]);
  const rotateY = useTransform(smoothX, [-60, 60], [-6, 6]);

  function handleMove(event) {
    if (!tilt) return;
    const rect = event.currentTarget.getBoundingClientRect();
    x.set(event.clientX - rect.left - rect.width / 2);
    y.set(event.clientY - rect.top - rect.height / 2);
  }

  function handleLeave() {
    x.set(0);
    y.set(0);
  }

  return (
    <motion.div
      className={`animated-image ${className}`}
      animate={floating ? { y: [0, -14, 0] } : undefined}
      transition={floating ? { duration: 5, repeat: Infinity, ease: "easeInOut" } : undefined}
      style={tilt ? { rotateX, rotateY, transformStyle: "preserve-3d" } : undefined}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      whileHover={tilt ? { scale: 1.025 } : undefined}
    >
      <img src={src} alt={alt} />
    </motion.div>
  );
}
